import { render } from "./LibraryShow.vue?vue&type=template&id=053ba650"
import script from "./LibraryShow.vue?vue&type=script&lang=js"
export * from "./LibraryShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__